export default __webpack_public_path__ + "static/media/The Light.c780e1cb.mp3";